var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "title-align-" + _vm.localTitleAlign + " title" }, [
    !_vm.editingTitle
      ? _c(
          "h3",
          {
            class: "h1-size-" + _vm.localTitleSize,
            on: { click: _vm.focusTitle },
          },
          [_vm._v(_vm._s(_vm.displayTitleText))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.editingTitle
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localTitleText,
              expression: "localTitleText",
            },
          ],
          ref: "titleInput",
          class:
            "h1-size-" + _vm.localTitleSize + " title-input main-title-input",
          attrs: { type: "text", placeholder: "Başlık" },
          domProps: { value: _vm.localTitleText },
          on: {
            blur: _vm.stopEditingTitle,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.stopEditingTitle.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localTitleText = $event.target.value
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    !_vm.editingSubTitle && (_vm.localSubTitle || !_vm.editingTitle)
      ? _c(
          "h5",
          {
            class: "h3-size-" + _vm.localTitleSize,
            on: { click: _vm.focusSubTitle },
          },
          [_vm._v(_vm._s(_vm.displaySubTitle))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.editingSubTitle
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localSubTitle,
              expression: "localSubTitle",
            },
          ],
          ref: "subTitleInput",
          class:
            "h3-size-" + _vm.localTitleSize + " title-input sub-title-input",
          attrs: { type: "text", placeholder: "Bir alt başlık yazın" },
          domProps: { value: _vm.localSubTitle },
          on: {
            blur: _vm.stopEditingSubTitle,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.stopEditingSubTitle.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localSubTitle = $event.target.value
            },
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }